import { Alert, Link } from '@yoast/ui-library';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import type { Brand } from '../api/generated/insights.schemas';
import { useBrandAnalysisMutations } from '../contexts';

interface AlertFinishBrandSetupProps {
  brand: Brand;
}

const AlertFinishBrandSetup: React.FC<AlertFinishBrandSetupProps> = ({
  brand,
}) => {
  const navigate = useNavigate();
  const { setBrandId } = useBrandAnalysisMutations();

  if (brand?.setupStatus === 'pendingQuerySelection') {
    return (
      <Alert className="yst-mt-0">
        <div className="yst-max-w-xl yst-space-y-4">
          {/* content */}
          <div className="yst-space-y-2">
            <h3 className="yst-font-medium">
              Finish your analysis for {brand?.name || `Brand ${brand?.id}`}
            </h3>
            <p>
              Your brand is saved, but you haven&rsquo;t completed the analysis
              yet. Review your queries and run the analysis to get your brand
              insights!
            </p>
          </div>

          {/* actions */}
          <div className="yst-flex yst-justify-start yst-gap-6">
            <Link
              onClick={() => {
                if (brand.id) {
                  setBrandId(brand.id);
                  navigate(`/setup/${brand.id}/queries`);
                } else {
                  // TODO: do we need a user-facing error for this case?
                  console.error('Brand ID is missing.');
                }
              }}
            >
              Review queries
            </Link>
          </div>
        </div>
      </Alert>
    );
  }

  return null;
};

export default AlertFinishBrandSetup;
